import React from "react";
import { IColuna } from "../../../types/IColuna";
const estiloPesquisarCliente =
  require("../pesquisar-cliente.module.scss").default;

export type HeadersPesquisarClienteProps = {
  colunas: IColuna[];
};
const traduzirColuna = (nomeColuna: string) => {
  return nomeColuna == "ClienteAssociado" ? "Cliente Associado" : nomeColuna == "Informações" ? "" : nomeColuna;

};

export const HeadersPesquisarCliente = (
  props: HeadersPesquisarClienteProps
) => {
  return (
      <div className="_table-header-group"
        id="HeadersPesquisarCliente_TableGroup"
      >
        <div className="_table-row"
          id="HeadersPesquisarCliente_TableRow"
        >
          {props.colunas.map(
            (coluna, key) =>
              coluna.Selecionada && (
                <div
                  className={`_table-cell ${estiloPesquisarCliente.tableCellHeader}`}
                  key={key}
                  id={coluna.Codigo ? `HeadersPesquisarCliente_${coluna.Codigo}` : `HeadersPesquisarCliente_${coluna.Nome}`}
                >
                  {traduzirColuna(coluna.Nome)}
                  {coluna.Selecionada}
                </div>
              )
          )}
        </div>
      </div>
  );
};
